<div *ngIf="label" class="dropdown-label" [class.-disabled]="disabled">
  {{ label }}
</div>
<div class="dropdown" [ngStyle]="paddingStyle" [class.-active]="display">
  <div class="dropdown-value" [class.-active]="display" [class.-disabled]="disabled" [ngClass]="{ 'primary-color': textColor === 'primary' }">
    {{ value }}

    <ng-content select="[dropdown-value]"></ng-content>
  </div>
  <div *ngIf="!newDropdown">
    <span class="fa fa-chevron-down arrow" [class.-active]="display" [class.-disabled]="disabled"></span>
  </div>
  <app-svg-icon *ngIf="newDropdown" class="arrow" src="./assets/icons/dropdown-arrow"></app-svg-icon>
</div>

<div class="content" *ngIf="display">
  <ng-content select="app-dropdown-option"></ng-content>
</div>
